const linkResolver = (doc) => {
    // URL for a page type
    if (doc.type === 'page') return `/${doc.uid}`
    return '/'
}

export default linkResolver